const isBrowser = typeof window !== 'undefined';

// Storage interface to match localStorage API
interface Storage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

// SSR-safe storage implementation
class NoopStorage implements Storage {
  getItem(): null {
    return null;
  }

  setItem(): void {
    // No-op during SSR
  }

  removeItem(): void {
    // No-op during SSR
  }
}

const getStorage = (): Storage => {
  if (isBrowser) {
    return localStorage;
  }
  return new NoopStorage();
};

export default getStorage;
